"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PopoverMenu = _interopRequireDefault(require("../common/PopoverMenu/PopoverMenu"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./AccountsDropdownComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AccountsDropdown = /*#__PURE__*/function (_React$Component) {
  function AccountsDropdown() {
    var _this;
    _classCallCheck(this, AccountsDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AccountsDropdown, [].concat(args));
    _defineProperty(_this, "selectAccount", function (account) {
      if (location.pathname.startsWith('/exchange')) {
        var route = '/exchange/spot'; // default

        if (account.AccountType === 'Margin') {
          route = '/exchange/margin';
        } else if (account.AccountType === 'Futures') {
          route = '/exchange/futures';
        }
        _this.props.history.push(route);
      }
      _this.props.selectAccount(account.AccountId, account.OMSID);
    });
    _defineProperty(_this, "renderMenuItems", function () {
      var _this$props = _this.props,
        accounts = _this$props.accounts,
        selectedAccount = _this$props.selectedAccount,
        customClass = _this$props.customClass,
        t = _this$props.t;
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)(['accounts-dropdown', customClass]);
      var menuItems;
      if (accounts.length <= 1) {
        menuItems = [{
          label: selectedAccount.AccountName,
          customClass: bemClasses('username-in-dropdown')
        }];
      } else {
        menuItems = [{
          label: t('Account'),
          customClass: bemClasses('account-submenu-label')
        }].concat(_toConsumableArray(accounts.filter(function (account) {
          return _this.props.showSelectedAccount || account.AccountId !== selectedAccount.AccountId;
        }).sort(function (a, b) {
          // Define sort order: Unknown/Spot -> Asset -> Margin -> Futures
          var order = {
            Asset: 1,
            Margin: 2,
            Futures: 3
          };
          var aOrder = order[a.AccountType] || 0; // Unknown types go first (assumed spot)
          var bOrder = order[b.AccountType] || 0;
          return aOrder - bOrder;
        }).map(function (account) {
          var label = account.AccountName;
          var item = {
            label: label,
            onClick: function onClick() {
              return _this.selectAccount(account);
            }
          };
          if (selectedAccount.AccountId === account.AccountId) {
            item.customClass = 'selected';
          }
          return item;
        })));
      }
      return menuItems;
    });
    _defineProperty(_this, "formatAccountName", function (account) {
      if (!account || !account.AccountName) return '';
      if (account.AccountName.length > 5) {
        var truncated = account.AccountName.substring(0, 5) + '...';
        var accountType = account.AccountType === 'Asset' ? 'Spot' : account.AccountType;
        return truncated + accountType;
      }
      return account.AccountName;
    });
    return _this;
  }
  _inherits(AccountsDropdown, _React$Component);
  return _createClass(AccountsDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        selectedAccount = _this$props2.selectedAccount,
        customClass = _this$props2.customClass,
        t = _this$props2.t;
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)(['accounts-dropdown', customClass]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('container')
      }, ['page-dashboard', 'page-wallet', 'page-activity'].includes(customClass) && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('label')
      }, t('Account')), selectedAccount ? /*#__PURE__*/_react["default"].createElement(_PopoverMenu["default"], {
        customClass: bemClasses(),
        popoverProps: {
          trigger: function trigger(props) {
            return /*#__PURE__*/_react["default"].createElement("button", _extends({
              className: bemClasses('popover-menu-trigger')
            }, props), /*#__PURE__*/_react["default"].createElement("div", {
              className: bemClasses('accounts-info-container')
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: bemClasses('username-in-display'),
              title: selectedAccount.AccountName
            }, _this2.formatAccountName(selectedAccount)), /*#__PURE__*/_react["default"].createElement("span", {
              className: bemClasses('username-in-display-mobile'),
              title: selectedAccount.AccountName
            }, selectedAccount.AccountName), /*#__PURE__*/_react["default"].createElement("span", {
              className: bemClasses('popover-menu-trigger-triangle')
            })));
          },
          customClass: 'accounts-dropdown'
        },
        items: this.renderMenuItems()
      }) : /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        isInline: true,
        customClass: bemClasses
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(AccountsDropdown, "propTypes", {
  selectedAccount: _propTypes["default"].shape({
    AccountName: _propTypes["default"].string.isRequired
  }),
  accounts: _propTypes["default"].array.isRequired,
  logout: _propTypes["default"].func.isRequired,
  history: _propTypes["default"].object,
  settingsRoute: _propTypes["default"].string,
  activityRoute: _propTypes["default"].string,
  betaOptedIn: _propTypes["default"].string,
  showSelectedAccount: _propTypes["default"].bool
});
_defineProperty(AccountsDropdown, "defaultProps", {
  settingsRoute: ''
});
var _default = exports["default"] = (0, _reactI18next.withTranslation)()(AccountsDropdown);